
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["feather feather-activity",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"23","viewBox":"0 0 23 23","fill":"none","xmlns":"http://www.w3.org/2000/svg","class":"feather feather-activity"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.483 22.118c-.211-1.248-.768-2.592-1.67-4.032-.903-1.459-2.189-2.812-3.86-4.06-1.65-1.248-3.302-2.045-4.953-2.39v-1.21c1.632-.384 3.197-1.095 4.694-2.132a14.906 14.906 0 003.802-3.801c1.037-1.517 1.7-3.015 1.987-4.493h1.21c.173.96.518 1.949 1.037 2.966.518.999 1.18 1.959 1.987 2.88a17.759 17.759 0 002.765 2.448c1.516 1.076 3.062 1.786 4.636 2.132v1.21c-1.056.21-2.15.642-3.283 1.295a17.32 17.32 0 00-3.11 2.333c-.96.883-1.747 1.814-2.362 2.794-.902 1.44-1.459 2.793-1.67 4.06h-1.21z","fill":"currentColor"}})])
          )
        }
      }
    